import { Toast } from "bootstrap";
import { createRoot } from "react-dom/client";

export default function Alert(text, type) {

    let container = $('#toasts');
    if (!container.length) {
        container = $('<div id="toasts" class="toast-container position-fixed bottom-0 end-0 p-3"></div>');
        $('body').append(container);
    }

    const types = {
        error: 'bg-danger',
        success: 'bg-success',
        info: 'bg-info',
    }

    const toastContent = $('<div class="toast overflow-hidden" role="alert" aria-live="assertive" aria-atomic="true"></div>');
    toastContent.addClass(types[type]);
    container.append(toastContent);

    createRoot(toastContent[0]).render(
        <>
            <div className="toast-header">
                <strong className="me-auto">{T(text)}</strong>
                <button type="button" className="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
            </div>
        </>);

    const toastBootstrap = Toast.getOrCreateInstance(toastContent[0], {autohide: true});
    toastBootstrap.show();
    toastContent.on('hidden.bs.toast', () => toastContent.remove());
}